import React from 'react';
import autobind from 'autobind-decorator';

import {service as FileUploadService} from "../../Services/FileUploadService";

export class FileUploadViewer extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            fileUpload: null
        };
    }

    componentDidMount() {
        FileUploadService.GetFileUpload(this.props.FileUploadId)
            .then((x) => this.setState({fileUpload: x.result}))
            .catch((err) => this.setState({fileUpload: null}));
    }

    @autobind
    getFileName() {
        if(this.state.fileUpload) {
            return this.state.fileUpload.fileName;
        }
        return "";
    }

    @autobind
    download() {
        if(this.state.fileUpload) {
            FileUploadService.DownloadFile(
                this.state.fileUpload.fileName,
                this.state.fileUpload.fileUploadId
            )
        }
    }

    render() {
        return <div className="sb-context-node-viewer">
            <a
                className="sb-context-node-link"
                onClick={this.download}
            >
                {this.getFileName()}
            </a>
        </div>;
    }
}



